export const URL = "https://api.blueen.app/"
export const THIS_URL = "https://blueenopen-landing.enterscience.com.br"

export const BOPEN_URL = "https://blueenopen-dev.enterscience.com.br/"